import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { SoundManager } from "@lib/titan2/dist/game/manager/SoundManager";
import gsap from "gsap";
import { GameSoundEvent } from "./event/GameSoundEvent";
export class GameScatterSoundController extends SoundController {
    constructor(factory) {
        super(factory);
    }
    addEventListeners() {
        this.removeEventListeners();
        this.registerGame(GameSoundEvent.COCONUT_PLAYER_TAP, this.handlePlayerTap);
        this.registerGame(GameSoundEvent.COCONUT_CRACK, this.handleCrack);
        this.registerGame(GameSoundEvent.COCONUT_EXPLODE, this.handleExplode);
        this.registerGame(GameSoundEvent.COCONUT_EXPLODE_REVEAL, this.handleExplodeReveal);
        this.registerGame(GameSoundEvent.COCONUT_BUILDUP, this.handleBuildUp);
        this.registerGame(GameSoundEvent.COCONUT_ORBIT, this.handleOrbit);
        this.registerGame(GameSoundEvent.COCONUT_APPEAR, this.handleAppear);
    }
    handleOrbit() {
        this.orbit = this.playSound(GameScatterSoundConstants.getOrbitSound());
    }
    handleAppear() {
        this.playSound(GameScatterSoundConstants.getAppearSound());
    }
    handlePlayerTap() {
        this.orbit?.stop();
        const index = this.baseModel.getPickTaps();
        this.playSound(GameScatterSoundConstants.getNextTapSound(index));
    }
    async handleCrack() {
        await gsap.to({}, { duration: 0.05 }); //a tiny delay otherwise it gets muffled with the tap sound
        const index = this.baseModel.getPickTaps();
        this.playSound(GameScatterSoundConstants.getNextCrackSound(index));
    }
    handleExplode() {
        this.tension?.stop();
        this.tension = undefined;
        this.playSound(GameScatterSoundConstants.getExplode());
        this.playSound(this.soundManager.getRegisteredSound("REEL_STRIKE_JOKER"));
    }
    handleExplodeReveal() {
        if (this.baseModel.getChanceGame()?.getParams().getMultiplier() > 1) {
            this.playSound(this.soundManager.getRegisteredSound("GAME_SUMMARY_WIN_1")).volume(0.9);
        }
    }
    async handleBuildUp() {
        this.tension?.stop();
        //If the next pick will be an explosion, then we will play tension
        if (this.baseModel.getPickTaps() + 1 >= this.baseModel.getPickTapsRequired()) {
            this.tension = this.playSound(GameScatterSoundConstants.getTension());
        }
        else {
            const taps = this.baseModel.getPickTaps();
            this.tension = this.playSound(GameScatterSoundConstants.getBuildUp(taps));
        }
    }
}
export class GameScatterSoundConstants {
    constructor() { }
    static getAppearSound() {
        return SoundManager.getInstance().getRegisteredSound("COCONUT_APPEAR");
    }
    static getOrbitSound() {
        return SoundManager.getInstance().getRegisteredSound("COCONUT_ORBIT");
    }
    static getTension() {
        return SoundManager.getInstance().getRegisteredSound("COCONUT_TENSION");
    }
    static getBuildUp(taps) {
        return SoundManager.getInstance().getRegisteredSound(`COCONUT_BUILD_UP_${taps}`);
    }
    static getNextTapSound(taps) {
        const MAX_TAP_INDEX = 7;
        const index = Math.min(taps, MAX_TAP_INDEX);
        return SoundManager.getInstance().getRegisteredSound(`COCONUT_TAP_${index}`);
    }
    static getNextCrackSound(taps) {
        const MAX_TAP_INDEX = 7;
        const index = Math.min(taps, MAX_TAP_INDEX);
        const variant = Math.random() < 0.5 ? "" : "B";
        return SoundManager.getInstance().getRegisteredSound(`COCONUT_CRACK_${index}${variant}`);
    }
    static getExplode() {
        return SoundManager.getInstance().getRegisteredSound("COCONUT_EXPLODE");
    }
}
//# sourceMappingURL=GameScatterSoundController.js.map